module.exports = __webpack_public_path__ + "img/1716360210893-WhatsApp Image 2024-05-22 at 14.36.29.jpeg.3a512207.webp";